export default __webpack_public_path__ + "static/media/kitchen4-afterA-1024w.fa6ce872.png";